export const EXPORT_PDF_DATA = 'data:application/pdf;base64';
export const EXPORT_DOCX_DATA =
  'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64';

export const EXPORT_XLS_DATA = 'data:application/vnd.ms-excel;base64';
export const EXPORT_ZIP_DATA = 'data:application/zip;base64';

export const EXCEL_ACCEPT = '.xls,.xlsx,.xlsm';
